<template>
  <div class="card-body meters">
    <!-- Status Dot -->
    <div
      v-if="activeConfigInfo.MeterStatus == 'Live' && !activeMeterInfo.Removed"
      class="dot-active float-right"
    ></div>
    <div v-else class="dot float-right"></div>
    <!-- Latest Reading -->
    <div class="meter_reading mt-4" v-if="readings && latestReading">
      <ul class="list-unstyled font-weight-bold d-flex justify-content-around">
        <li v-for="(num, index) in latestReading" :key="index">{{num}}</li>
      </ul>
    </div>
    <div class="all_meter_info mt-3" v-if="activeMeterInfo && activeConfigInfo">
      <!-- Meter Serial -->
      <div class="meter serial pb-2">
        <h6 class="d-inline-block pr-2">Meter Serial:</h6>
        <p class="d-inline-block">{{activeMeterInfo.Serial}}</p>
      </div>
      <div>
        <img src="@/assets/img/barcode.png" class="img-fluid pb-2" alt="Barcode" />
      </div>
      <!-- Meter Type -->
      <div class="meter_info">
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Meter Type:</p>
          </div>
          <div class="d-inline-block right">
            <p class="text-capitalize">{{activeMeterInfo.MeterMechanism}}</p>
          </div>
        </div>
        <!-- Metric or Imperial -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Metric or Imperial:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.IsImperial">Imperial</p>
            <p v-else>Metric</p>
          </div>
        </div>
        <!-- Number of Dials -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Number of Dials:</p>
          </div>
          <div class="d-inline-block right">
            <p>{{activeConfigInfo.Dials || activeMeterInfo.Dials}}</p>
          </div>
        </div>
        <!-- Automated Readings -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Automated Readings:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.IsAmr">True</p>
            <p v-else>False</p>
          </div>
        </div>
        <!-- Reading Factor -->
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Reading Factor:</p>
          </div>
          <div class="d-inline-block right">
            <p>{{activeMeterInfo.ReadingFactor}}</p>
          </div>
        </div>

        <!-- Multiplication Factor -->
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Multiplication Factor:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.MultiplicationFactor != null">{{activeMeterInfo.MultiplicationFactor.toFixed(3)}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Location -->
        <div class="mb-4 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Location:</p>
          </div>
          <div class="d-inline-block right" v-if="activeConfigInfo">
            <p>{{activeConfigInfo.Location | splitString}}</p>
          </div>
        </div>
        <!-- Status -->
        <div class="mb-4 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Status:</p>
          </div>
          <div class="d-inline-block right" v-if="activeConfigInfo">
            <p>{{ activeConfigInfo.MeterStatus }}</p>
          </div>
        </div>
        <!-- Install Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Install Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeConfigInfo.EffectiveFrom">{{activeConfigInfo.EffectiveFrom | shortDate}}</p>
            <p v-else-if="activeMeterInfo.Installed">{{activeMeterInfo.Installed | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Removed Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Removed Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.Removed">{{activeMeterInfo.Removed | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Last Validated Read -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold text-white">Last Validated Read:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.LastCheckRead">{{activeMeterInfo.LastCheckRead | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import metersMixin from '@/mixins/meterInfo/meters/meters.js';

export default {
  name: 'gasMeter',
  mixins: [metersMixin],
  computed: {
    currentMeter() {
      // Gets the currently active meter or last active meter. Use ONLY for setting default vaules.
      let that = this;
      return (
        this.$_.find(this.meters, (meter) => {
          return that.$_.find(meter.MeterConfigs, (config) => {
            return config.MeterStatus === 'Live';
          });
        }) ||
        (this.meters || []).find(m => m.SharedId == (this.meters || [])
          .flatMap((meter) => meter.MeterConfigs)
          .reduce(
            (l, config) =>
              l.EffectiveFrom > config.EffectiveFrom ? l : config,
            {}
          ).MeterSharedId)
      );
    },
    currentConfig() {
      // Gets the currenly active meter config or last active config. Use ONLY for setting default vaules.
      return (
        this.$_.find(this.currentMeter.MeterConfigs, (config) => {
          return config.MeterStatus === 'Live';
        }) ||
        (this.currentMeter.MeterConfigs || []).reduce(
          (l, config) => (l.EffectiveFrom > config.EffectiveFrom ? l : config),
          {}
        )
      );
    },
    readings() {
      return this.$store.state.meters.activeService.Readings;
    },
    latestReading() {
      if (this.readings && this.activeMeterInfo) {
        let reading = this.$_.sortBy(this.readings, 'ReadingDate')
          .reverse()
          .find((reading) => reading.Serial == this.activeMeterInfo.Serial);
        if (reading) {
          const dials = reading.Dials || this.activeConfigInfo.Dials || this.activeMeterInfo.Dials;
          if (reading.hasOwnProperty('ConverterCorrectedReading')) {
            return Array.from(
              reading.ConverterCorrectedReading.toString().padStart(
                dials,
                '0'
              )
            );
          } else {
            return Array.from(
              reading.MeterReading.toString().padStart(
                dials,
                '0'
              )
            );
          }
        }
        return reading;
      }
    },
  },
};
</script>
